module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b825482327b3a30eff94a36296193d78.png";